import './OneAccount.css';
import '../../chaptercontainer.css'

const OneAccount = ({
  question,
  answers,
  isAnswerChecked,
  onSelect
}) => {
  const answer = answers?.[0];

  const renderOption = (
    side,
    symbol
  ) => {
    const selected =
      answer?.side === side &&
      answer?.variation === symbol;

    const correct =
      isAnswerChecked &&
      question.correctSide === side &&
      question.correctVariation === symbol;

    const incorrect =
      isAnswerChecked &&
      selected &&
      !correct;

    return (
      <button
        key={`${side}-${symbol}`}
        type="button"
        className={`
          one-account-option
          ${selected ? 'selected' : ''}
          ${correct ? 'correct' : ''}
          ${incorrect ? 'incorrect' : ''}
        `}
        onClick={() =>
          onSelect(
            0,
            side,
            symbol
          )
        }
        disabled={isAnswerChecked}
      >
        {symbol}
      </button>
    );
  };

  return (
    <div className="quiz-content-scroll-bc">
      <div className="one-account-shell">

        {question?.imageoperation && (
          <div className="one-account-image">
            {question.imageoperation}
          </div>
        )}

        <div
          className="one-account-statement"
          dangerouslySetInnerHTML={{
            __html:
              question?.statement ||
              question?.context ||
              ''
          }}
        />

        <div className="one-account-card">

          <div className="one-account-header">
            <div className="one-account-debit">
              D
            </div>

            <div className="one-account-title">
              {question?.account || ''}
            </div>

            <div className="one-account-credit">
              C
            </div>
          </div>

          <div className="one-account-body">

            <div className="one-account-side">
              {['↑', '↓'].map(
                (symbol) =>
                  renderOption(
                    'D',
                    symbol
                  )
              )}
            </div>

            <div className="one-account-divider" />

            <div className="one-account-side">
              {['↑', '↓'].map(
                (symbol) =>
                  renderOption(
                    'C',
                    symbol
                  )
              )}
            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default OneAccount;